var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('Number'),_c('Brand'),_c('News'),_c('Service'),_c('Cloud'),_c('Business'),_c('Banner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }